import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const BusinessIntelligence = {
  Helmet: lazy(() => import('./components/Helmet')),
  Reporting: {
    Layout: lazy(() => import('./containers/Reporting')),
    Report: lazy(() => import('./containers/Reporting/pages/ReportType/Report')),
    ReportType: lazy(() => import('./containers/Reporting/pages/ReportType/ReportType')),
    List: lazy(() => import('./containers/Reporting/pages/ReportListPage')),
    ListV2: lazyNamed(() => import('./containers/Reporting/pages/ReportList'), 'ReportList'),
  },
  Visualizations: {
    Widget: lazy(() => import('./containers/Visualizations/Widgets/Form')),
    Widgets: lazy(() => import('./containers/Visualizations/Widgets/List')),
    DashboardView: lazy(() => import('./containers/Visualizations/Dashboards/View')),
    DashboardEdit: lazy(() => import('./containers/Visualizations/Dashboards/Form')),
    Dashboards: lazy(() => import('./containers/Visualizations/Dashboards/List')),
  },
};

export default BusinessIntelligence;
